<div class="popup-model popup-md shadow top" data-attr="terrain-save-modal">
  <div class="d-flex justify-content-between align-items-center pink-header p-2">
    <h5 class="flex-grow-1 text-center mt-1">{{'TERRAIN_SAVE.TITLE' | translate}}</h5>
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="cancel()">
        <img src="assets/icon/close.svg" alt="Close" />
      </button>
    </div>
  </div>

  <div class="p-4">
    <h6 class="mb-3">{{'TERRAIN_SAVE.QUESTION' | translate}}</h6>

    <fieldset class="save-options">
      <legend class="visually-hidden">{{'TERRAIN_SAVE.QUESTION' | translate}}</legend>

      <!-- Sentinelle plutôt que null : RadioControlValueAccessor résout la valeur de façon
           asynchrone, et une comparaison stricte avec null est fragile. -->
      <label class="save-option" [class.selected]="selection === APPEND">
        <input type="radio" name="terrainTarget" data-attr="terrain-save-add" [value]="APPEND" [(ngModel)]="selection" />
        <span class="save-option__label">
          <b>{{'TERRAIN_SAVE.ADD_VERSION' | translate}}</b>
          <small class="text-muted d-block">{{'TERRAIN_SAVE.ADD_VERSION_HINT' | translate}}</small>
        </span>
      </label>

      <!-- track $index : deux versions peuvent porter le même nom, un track par nom lèverait NG0955 -->
      @for (version of existingVersions; track $index; let i = $index) {
        <label class="save-option" [class.selected]="selection === i">
          <input type="radio" name="terrainTarget" [attr.data-attr]="'terrain-save-replace-' + i" [value]="i" [(ngModel)]="selection" />
          <span class="save-option__label">
            <b>{{'TERRAIN_SAVE.REPLACE' | translate}} « {{ version }} »</b>
          </span>
        </label>
      }
    </fieldset>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-secondary" (click)="cancel()">
        {{'GLOBAL.ANNULER' | translate}}
      </button>
      <button type="button" class="btn btn-primary" data-attr="terrain-save-confirm" (click)="confirm()">
        <i class="fas fa-save me-2"></i>{{'GLOBAL.SAVE_TERRAIN' | translate}}
      </button>
    </div>
  </div>
</div>
